export enum SimulatorCurationStatus {
  'Registered with BioSimulators' = 1,
  'Algorithms curated' = 2,
  'Parameters curated' = 3,
  'Image available' = 4,
  'Image validated' = 5,
}
